import { isObject } from 'lodash'
import { sniff } from '@/util'
import { shareConfigProps, fixedUrl } from './shareConfig'

const shareTo = function (config: shareConfigProps ): void {
  // 非对象并且不是空字符串时，直接返回
  if ( !isObject(config) && !(config?.url || config?.path) ) return
  const isHttpUrl = /^http[s]?:/.test(config?.url)

  // 测试环境subenv处理
  config.url = fixedUrl(config?.url)

  // 如果传入ytpe，则前端设置 唯一id
  if(config.type === 'ipMachineMinprogram' || config.type === 'onlyMinprogram') {
    config.username = 'gh_cd8a0ab4f404'  // 抽卡小程序唯一id
  }

  // 设置跳转地址
  if ( isHttpUrl && config.username && !config.path ) {
    config.path = `/pages/web-view-custom/web-view-custom?url=${encodeURIComponent(config?.url)}`
  }

  let jsonStr = ''
  try {
    jsonStr = JSON.stringify(config)
  } catch (error) {
    jsonStr = ''
  }

  if (sniff.isUboxAndroidApp) {
    window.app?.shareTo && window.app?.shareTo(jsonStr)
  } else if (sniff.isUboxIosApp) {
    window?.webkit?.messageHandlers?.shareTo && window?.webkit?.messageHandlers?.shareTo.postMessage(jsonStr)
  } else if ( sniff.isWechatMiniProgram ) {
    window.wx.miniProgram.postMessage({ shareConfig: config })
  }
}

export default shareTo